import React from 'react';

import useObjectSearchParams from 'hooks/useObjectSearchParams';
import useSetDeleteURLParams from 'hooks/useSetDeleteURLParams';

interface CategoryFilterParams {
  categoryId: string;
}

const useCategoryFilter = () => {
  const { categoryId } = useObjectSearchParams<CategoryFilterParams>();
  const { setURLParam, deleteURLParam } =
    useSetDeleteURLParams<CategoryFilterParams>();

  const setCategoryId = React.useCallback(
    (next: string | null) => {
      if (next) {
        setURLParam('categoryId', next);
      } else {
        deleteURLParam('categoryId');
      }
    },
    [setURLParam, deleteURLParam]
  );

  return { categoryId: categoryId || '', setCategoryId };
};

export default useCategoryFilter;
